import { PdfViewerStyleAPIResponse, PdfViewerStylesHttpResponse } from 'app/types/pdfViewerStyles';
import { getPdfViewerStyles } from 'core/crud/pdfViewerStyles.crud';
import { createCachedProgramResource } from 'core/lite/hooks/createCachedProgramResource';

type CachedStyles = PdfViewerStyleAPIResponse[] | undefined;

export type UsePdfViewerStylesResult = {
  customHotspotsImages: CachedStyles;
  isReady: boolean;
};

const { useResource, clearCache } = createCachedProgramResource<CachedStyles>(async (programGuid) => {
  const response: PdfViewerStylesHttpResponse = await getPdfViewerStyles(programGuid);
  const httpStatus = response?.status ?? response?.error?.status;

  if (httpStatus === 200) return { value: response?.data?.data, isCacheable: true };

  // El 404 "este programa no tiene estilos" es determinista; el resto se reintenta al siguiente montaje.
  return { value: undefined, isCacheable: httpStatus === 404 };
}, undefined);

// Solo para tests: aísla casos; en runtime no se invoca.
export const __clearPdfViewerStylesCache = clearCache;

export default function usePdfViewerStyles(programGuid: string | undefined): UsePdfViewerStylesResult {
  const { value, isReady } = useResource(programGuid);

  return { customHotspotsImages: value, isReady };
}
